import axios from 'axios';

const apiClient = axios.create({
  baseURL: window.AppConfig?.apiUrl || 'https://localhost:3001/',
  headers: {
    'Content-Type': 'application/json'
  },
});

// Nur für Entwicklungszwecke!
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
}

export default apiClient;